import { message, Select } from "antd";
import axios from "axios";
import { create } from "zustand";

export let useTransaction = create((set, get) => ({
    // customer_id, transaction_type, amount, currency, status, transaction_date, description, created_at, updated_at, first_name, last_name
    columns: [
        {
            title: 'Kontragent',
            dataIndex: 'first_name',
            key: 'first_name',
            render: (text, record) => `${record.first_name} ${record.last_name}`
        },
        {
            title: 'Turi',
            dataIndex: 'transaction_type',
            key: 'transaction_type',
            render: (_, record) => record.transaction_type === 'debit' ? 'Chiqim' : 'Kirim'
        },
        {
            title: "Chiqim",
            dataIndex: 'amount',
            key: 'amount',
            render: (text, record) => (record.transaction_type === 'debit') ? `${record.amount}` : `0`
        },
        {
            title: 'Kirim',
            dataIndex: 'amount',
            key: 'amount2',
            render: (text, record) => (record.transaction_type === 'credit') ? `${record.amount}` : `0`
        },
        {
            title: 'Valyuta',
            dataIndex: 'currency',
            key: 'currency',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => <Select value={record.status} onChange={(value) => {
                record.status = value;
                get().updateTransactionStatus(record);
            }} options={[
                { value: 'pending', label: 'Jarayonda' },
                { value: 'completed', label: 'Bajarilgan' },
                { value: 'failed', label: 'Bajarilmagan' },
            ]} />
        },
        {
            title: 'Bajarilgan vaqti',
            dataIndex: 'transaction_date', 
            key: 'transaction_date',
        },
        {
            title: 'Izoh',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Yaratilgan',
            dataIndex: 'created_at',
            key: 'created_at',
        },
        {
            title: 'Tahrirlangan',
            dataIndex: 'updated_at',
            key: 'updated_at',
        },
    ],
    transactions: [],
    ed: {},
    setEd: (ed) => set({ ed }),
    transaction: [],
    kontr: [],
    getKontr: ()=>{
        axios.get('kontrs').then(res=>{
            set({ kontr: res.data });
        })
    },
    getKontrTr: (uid) => {
        axios.get('/transactions/' + uid)
            .then(response => {
                set({ transaction: response.data });
            })
            .catch(error => {
                console.error('Error fetching transactions:', error);
            });
    },
    fetchTransactions: async () => {
        try {
            const response = await axios.get('/transactions');
            set({ transactions: response.data });
        } catch (error) {
            console.error('Error fetching transactions:', error);
        }
    },
    addTransaction: async (transaction) => {
        try {
            await axios.post('/transactions', transaction);
            get().fetchTransactions();
            message.success('Transaction added successfully');
        } catch (error) {
            console.error('Error adding transaction:', error);
        }
    },
    updateTransaction: async (transaction) => {
        try {
            await axios.put(`/transactions/${transaction.id}`, transaction);
            get().fetchTransactions();
            message.success('Transaction updated successfully');
        } catch (error) {
            console.error('Error updating transaction:', error);
        }
    },
    updateTransactionStatus: async (transaction) => {
        try {
            await axios.put(`/updatetransstatus/${transaction.id}`, transaction);
            get().fetchTransactions();
            message.success('Transaction updated successfully');
        } catch (error) {
            console.error('Error updating transaction:', error);
        }
    },
    deleteTransaction: async (_, id) => {
        try {
            await axios.delete(`/transactions/${id.id}`);
            get().fetchTransactions();
            message.success('Transaction deleted successfully');
        } catch (error) {
            console.error('Error deleting transaction:', error);
        }
    },
}));
